<div class="benefit-wrapper">
  <div class="top-bene flexdiv">
    <div *ngFor="let item of benefits" class="box">
      <div class="{{item.imgClass}} sprite"></div>
      <div class="m-flex">
        <div class="heading">{{item.heading}}</div>
        <div class="descr">{{item.description}}</div>
      </div>
    </div>
  </div>
</div>
